import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const commentDeleteApi = createAsyncThunk(
  "auth/comment/delete",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.delete(apiRoutes.publicapiAction(`deleted_comment`, 1), { data });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const commentDeleteSlice = createSlice({
  name: "comment delete",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(commentDeleteApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(commentDeleteApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(commentDeleteApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const commentDeleteReducer = commentDeleteSlice.reducer;
